import React from 'react';

import BillDetailsEditContainer from '../../../bills/components/edit/BillDetailsEditContainer';
import { BillContext } from '../../../bills/types/Bill';

export default function BillReviewDetailsEditScreen() {
    return <BillDetailsEditContainer context={BillContext.REVIEW} />;
}
